import { render, staticRenderFns } from "./date-block.vue?vue&type=template&id=25b8bfe5&scoped=true"
import script from "./date-block.vue?vue&type=script&lang=js"
export * from "./date-block.vue?vue&type=script&lang=js"
import style0 from "./date-block.vue?vue&type=style&index=0&id=25b8bfe5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b8bfe5",
  null
  
)

export default component.exports